const crmRoutes = [
  {
    path: '/crm/client_mgr',
    name: 'crm.sidebar_client',
    component: () => import('@/views/crm/client')
  },
  // {
  //   path: '/crm/plan_mgr',
  //   name: 'crm.sidebar_plan',
  //   component: () => import('@/views/crm/plan')
  // },
  {
    path: '/crm/setting',
    name: 'crm.sidebar_setting',
    component: () => import('@/views/crm/setting'),
    children: [
      {
        path: '/crm/client_info',
        name: 'crm.sidebar_info',
        component: () => import('@/views/crm/setting/clientInfo')
      },
      {
        path: '/crm/client_tag',
        name: 'crm.sidebar_tag',
        component: () => import('@/views/crm/setting/clientTag')
      }
      // ,
      // {
      //   path: '/crm/client_blacklist',
      //   name: 'crm.sidebar_blacklist',
      //   component: () => import('@/views/crm/setting/clientBlackList')
      // },
      // {
      //   path: '/crm/client_savingrules',
      //   name: 'crm.sidebar_saving_rules',
      //   component: () => import('@/views/crm/setting/clientSavingRules')
      // }
      // ,
      // {
      //   path: '/crm/client_contactplan',
      //   name: 'crm.sidebar_contact_plan',
      //   component: () => import('@/views/crm/setting/clientContactPlan')
      // }
    ]
  }
]
export default crmRoutes
